<app-outcome-screen [title]="'Bienvenue ' + visitorName()">
  <p class="visitor-welcome__text">
    Votre hôte a été notifié de votre arrivée et va venir vous accueillir.<br />
    Nous vous invitons à attendre dans le salon d'accueil.<br />
    Avant de quitter les lieux, pensez à signaler votre départ.
  </p>
</app-outcome-screen>
